/* eslint-disable max-lines-per-function */
import React from "react";
import { useQuery } from "@apollo/client";
import { Link, Routes, Route, useParams } from "react-router-dom";
import { Feature, PropertyDuplicates } from "types/gql-types";
import { PROPERTY_DUPLICATES } from "pages/duplicates/queries";
import InterestProfileSlideout from "pages/dashboard/interests-profile-slideout/components/slideout";
import { Viewer } from "components/auth/types";
import { ContainerCardLayout } from "components/haven-design";
import { isPropertyFeatureEnabled } from "pages/dashboard/interests";
import { DuplicateTable } from "./table";

type Props = {
  viewer: Viewer;
}

export const Duplicates: React.FC<Props> = ({ viewer }) => {
  const { interestListId } = useParams();
  const { data, loading, error, refetch } = useQuery<PropertyDuplicates>(PROPERTY_DUPLICATES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: { id: interestListId },
  });

  const features = data?.interestList?.property?.features || [];
  const slideoutEnabled = isPropertyFeatureEnabled(features, Feature.INTEREST_PROFILE_SLIDEOUT);

  if (error || !interestListId) return <span>Error loading duplicates</span>;
  if (!data) return null;


  return (
    <ContainerCardLayout title={(
      <div style={{ marginBottom: 10 }}>
        <Link to={`/dash/manager/lists/${interestListId}`}>
          <i
            className="fa fa-chevron-left"
            style={{ fontSize: 18, marginRight: 4, marginTop: -1 }}
          />
            All Applications
        </Link>
      </div>
    )}
    subtitle={(<h3 style={{ marginBottom: 50 }}>
      {data.interestList.name} - Duplicates
      <small
        style={{ marginLeft: 10, cursor: "pointer", display: "inline-block" }}
        onClick={() => (loading ? null : refetch())}
      >
        <span className="fa fa-refresh" aria-hidden="true" />
              &nbsp; {loading ? "Loading" : "Refresh"}
      </small>
    </h3>)}
    >

      {!data.interestList?.property?.duplicates.length && (
        <h5 style={{ textAlign: "center", marginTop: 100 }}>There are no duplicates</h5>
      )}

      {data.interestList?.property?.duplicates.map((x) => (
        <div
          key={`${x.candidates.map((c) => c.id).join()}-${x.matchedFields.join()}`}
          style={{ marginBottom: 40, width: "100%", display: "grid" }}
        >
          <div style={{ overflowX: "auto" }}>
            <DuplicateTable
              showSocial={x.showSocialColumn}
              candidates={x.candidates}
              matchedFields={x.matchedFields}
              interestListId={interestListId}
              slideoutEnabled={slideoutEnabled}
            />
          </div>
        </div>
      ))}

      {slideoutEnabled && (
        <Routes>
          <Route path="interests/:interestId/*" element={<InterestProfileSlideout
            viewer={viewer}
            listId={interestListId}
            sendFullAppToInterestsEnabled={false}
          />}
          />
        </Routes>
      )}
    </ContainerCardLayout>
  );
};
